import { render, staticRenderFns } from "./RoleCardMenu.vue?vue&type=template&id=01970544"
import script from "./RoleCardMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./RoleCardMenu.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports